import styled from "styled-components";

const $ExpressCodeGooglePassButton = styled.div`
  .google-pass-button-container {
    display: flex;
    justify-content: center;
    height: 48px;
    width: 173px;
    margin: auto;
    margin-bottom: 16px;
    position: relative;
  }
  
  .google-pass-image {
    max-width: 100%;
    cursor: pointer;
    transition: opacity 0.2s ease-in-out;
    
    &:hover:not(:disabled) {
      opacity: 0.8;
    }
    
    &:focus {
      outline: 2px solid var(--primary-color, #007bff);
      outline-offset: 2px;
      border-radius: 4px;
    }
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
    
    &.loading {
      opacity: 0.6;
    }
  }

  .loading-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid var(--primary-color, #007bff);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  div.error-banner {
    display: flex;
    width: 100%;
    padding: 16px;
    border-radius: 12px;
    background-color: var(--warning-soft);
    line-height: 20px;
    margin-top: 24px;
    
    .icon {
      margin-right: 16px;
      &,
      svg {
        width: 16px;
        height: 16px;
      }
      & > svg > path {
        fill: var(--warning-bold);
      }
    }
    
    div.error-text {
      font-weight: 500;
      font-size: 13px;
      color: var(--warning-bold);
    }
  }

  /* Dark mode support */
  @media (prefers-color-scheme: dark) {
    .google-pass-image {
      &:focus {
        outline-color: var(--primary-color-dark, #66b3ff);
      }
    }
    
    .loading-spinner {
      border-color: #666;
      border-top-color: var(--primary-color-dark, #66b3ff);
    }
  }

  /* Responsive design */
  @media (max-width: 480px) {
    .google-pass-button-container {
      width: 100%;
      max-width: 173px;
    }
  }
`;

export default $ExpressCodeGooglePassButton;
